{
  "steps": {
    "onboardingValidationStepInProgress": {
      "PrescanAccepted": "Pre-Scan geaccepteerd",
      "InviteToApp": "Klant uitnodigen voor de app en offerte versturen",
      "QuoteAndFrameworkAgreement": "Offerte en raamovereenkomst tekenen",
      "Sepa": "Sepa machtiging tekenen",
      "Psd": "Bankrekeningen controleren",
      "TreatmentFee": "Behandelkosten betalen",
      "Collaterals": "Zekerheden uploaden",
      "ActivateFacility": "Faciliteit activeren"
    },
    "onboardingValidationStepCompleted": {
      "PrescanAccepted": "Pre-Scan geaccepteerd",
      "InviteToApp": "De uitnodiging voor de app en offerte zijn verstuurd.",
      "QuoteAndFrameworkAgreement": "Offerte raamovereenkomst getekend en gecontroleerd",
      "Sepa": "Sepa machtiging tekenen",
      "Psd": "Bankrekeningen gekoppeld en gecontroleerd",
      "TreatmentFee": "Behandelkosten betalen",
      "Collaterals": "Zekerheden uploaden",
      "ActivateFacility": "Faciliteit activeren"
    }
  },
  "fields": {
    "labels": {
      "addBankAccountToConnect": "Bankrekening toevoegen om te koppelen",
      "iban": "IBAN",
      "directDebitLimit": "Incassolimiet"
    }
  },
  "messages": {
    "noSigningAuthorities": "Er zijn nog geen ondertekenaars toegevoegd.",
    "noInvitePermission": "Je hebt geen toestemming om offertes te versturen.",
    "noCreateFacilityPermission": "Je hebt geen toestemming om de faciliteit aan te maken.",
    "sendAt": "Verstuurd op {datum}",
    "quoteAndFrameworkAgreementNotCompleted": "De offerte en raamovereenkomst moeten eerst getekend worden.",
    "sepaNotCompleted": "De SEPA machtiging moet eerst (digitaal) ondertekend worden.",
    "sepaCompleted": "De SEPA machtiging is gecontroleerd op volledigheid en incassolimiet en geüpload naar Twikey door {user} op {at}",
    "creditFacilitiesAdded": "Faciliteit is aangemaakt en zekerheden zijn ingevoerd",
    "sepaNotPrinted": "De klant moet de SEPA machtiging nog tekenen.",
    "activateFacilityNoPermission": "Je hebt geen toestemming om de faciliteit te activeren",
    "notAllStepsCompleted": "Er zijn nog stappen die voltooid moeten worden voordat de faciliteit geactiveerd kan worden.",
    "allStepsCompleted": "Alle controles zijn doorlopen en akkoord bevonden.",
    "facilityActivated": "De faciliteit is geactiveerd door {user} op {at}",
    "sepaNoPermission": "Je hebt geen toestemming om de SEPA machtiging te uploaden.",
    "treatmentFeeCompleted": "{user} heeft de betaling voltooid op {date}",
    "treatmentFeeNotCompleted": "De klant moet de betaling nog voltooien.",
    "treatmentFeeNoPermission": "Je hebt geen toestemming om een betaling te registreren.",
    "treatmentFeeActionRequired": "Er is iets fout gegaan bij de betaling. De betaling heeft de volgende status: '{status}'.",
    "refinancingChecked": "Herfinanciering is gecontroleerd door {user} op {date}",
    "mustValidateRefinancing": "De eindcontrole op de zekerheden is nog niet afgerond."
  },
  "actions": {
    "addSigningAuthority": "Ondertekenaar toevoegen",
    "addAnotherSigningAuthority": "Nog een ondertekenaar toevoegen",
    "createFacility": "Faciliteit aanmaken",
    "invite": "Klant uitnodigen en offerte versturen",
    "collaterals": "Zekerheden",
    "sendRequestToConnect": "Stuur verzoek om te koppelen",
    "activateFacility": "Activeer faciliteit en informeer klant",
    "addTransfer": "Betaling toevoegen",
    "validateRefinancing": "Naar zekerheden",
    "resetSigningAuthorities": "Ondertekenaar(s) resetten"
  },
  "titles": {
    "onboarding": "Onboarding",
    "signingAuthorities": "Ondertekenaar(s)",
    "creditFacility": "Kredietfaciliteit",
    "refinancing": "Herfinanciering"
  },
  "psd": {
    "sepa": "(SEPA)"
  },
  "signingAuthorities": {
    "gender": {
      "Female": "Mevr.",
      "Male": "Dhr.",
      "Neutral": ""
    }
  },
  "errors": {
    "messages": {
      "bankAccountExists": "Deze bankrekening is al toegevoegd."
    }
  },
  "resetSigners": {
    "titles": {
      "resetSigners": "Ondertekenaar(s) resetten"
    },
    "messages": {
      "resetSigners": "Met deze handeling worden de ondertekenaar(s) gereset. Indien je de ondertekenaar(s) reset, wordt de gestuurde offerte ook geannuleerd en moet de offerte opnieuw worden verzonden naar de juiste ondertekenaar(s).\nDe ondertekenaar(s) krijgen hier geen bericht van.\n\nJe gaat de volgende ondertekenaar(s) resetten:"
    },
    "actions": {
      "reset": "Resetten"
    }
  },
  "restartOnboardingDialog": {
    "fields": {
      "labels": {
        "signers": "Ondertekenaars",
        "facilitiesAndCollaterals": "Faciliteiten en/of zekerheden",
        "isQuoteInvalid": "Uitwerking rekening courant faciliteit in offerte is niet juist",
        "areCollateralsInvalid": "Zekerheden en overige voorwaarden zijn niet juist",
        "identityNotMatching": "De naam {name} komt niet volledig overeen met de naam uit de identiteitscontrole",
        "nameNotMatching": "De naam {name} komt niet overeen met de naam uit de identiteitscontrole",
        "dateOfBirthNotMatching": "De geboortedatum van {name} komt niet overeen met de geboortedatum uit de identiteitscontrole",
        "areSignerIdentityValidationsIncomplete": "Onjuiste ondertekenaar(s) of onvoldoende ondertekenaar(s) opgenomen in de offerte en raamovereenkomst."
      }
    },
    "messages": {
      "intro": "Met deze handeling kan de onboarding van de klant opnieuw gestart worden. Hierbij kunnen de faciliteit, de zekerheden als de ondertekenaars worden aangepast als dat nodig is. Kies hieronder de reden waarom de onboarding opnieuw gestart moet worden en het systeem zal die stappen afwijzen en opnieuw klaar zetten voor de klant.",
      "warning": "Let op: Alle stappen ná de offerte en raamovereenkomst moeten in alle gevallen door de klant opnieuw worden afgerond.",
      "facilitiesAndCollaterals": "Indien een van de onderstaande redenen wordt aangevinkt, moeten de faciliteit én de zekerheden opnieuw ingevoerd worden in de onboarding. De aangevinkte redenen worden medegedeeld met de klant.",
      "signers": "De ondertekenaars kunnen altijd worden aangepast als de onboarding opnieuw wordt gestart, voordat de nieuwe offerte en raamovereenkomst worden verzonden. De aangevinkte redenen worden medegedeeld met de klant."
    },
    "titles": {
      "restartOnboarding": "Onboarding opnieuw starten",
      "facilitiesAndCollaterals": "Faciliteiten en/of zekerheden",
      "signers": "Ondertekenaars"
    },
    "actions": {
      "restartOnboarding": "Onboarding opnieuw starten"
    }
  },
  "validateQuoteSigners": {
    "titles": {
      "checkIdentity": "Identiteit(en) controleren",
      "signer": "Ondertekenaar"
    },
    "messages": {
      "signersChecked": "Alle bevoegdheden van de ondertekenaars zijn gecontroleerd en gevalideerd op volledigheid en juistheid door {name} op {at}",
      "financeReceiverNotCompleted": "De klant moet nog inloggen en de offerte tekenen.",
      "checkIdentity": "Controleer de identiteit op de getekende documenten.",
      "noSigners": "Er zijn nog geen ondertekenaars toegevoegd.",
      "noPermissions": "Je hebt geen toestemming om de identiteit(en) te controleren."
    },
    "actions": {
      "checkIdentity": "Identiteit(en) controleren",
      "restoreIdentityChecks": "Niet akkoord en herstel"
    },
    "identityValidation": {
      "steps": {
        "identity": "Identiteit(en)",
        "summary": "Samenvatting"
      }
    }
  }
}